import { connect } from 'react-redux';
import { closePreviewer } from '../../actions/media';
import MediaViewerComponent from './MediaViewerComponent';
import type { RootState } from '../../reducers/index';
import type { DispatchFromProps } from './types';

const mapStateToProps = (state: RootState) => {
	const mediaPreviewer = state.fabricEditor.views.mediaPreviewer;
	return {
		isOpen: mediaPreviewer?.isOpen || false,
		currentMediaItem: mediaPreviewer?.currentMediaItem || null,
	};
};

const mapDispatchToProps: DispatchFromProps = {
	closePreviewer,
};

export default connect(mapStateToProps, mapDispatchToProps)(MediaViewerComponent);
